import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "react-highcharts";
import PropTypes from 'prop-types';

export default class Chart extends React.Component { 

  constructor(props) {
    super(props);    
    let series = [{
      name: "Total Returns",
      data: [
        parseFloat(props.data.returnsYTD),
        parseFloat(props.data.oneY),
        parseFloat(props.data.fiveY),
        parseFloat(props.data.tenY)
      ],
      color: "#e37222",
      class: "not-bold",
      style: { cursor: "none" },
      events: {
        legendItemClick: function(e) {
          e.preventDefault();
        }
      }
    }];

    if(props.data.benchmark !== null && typeof props.data.benchmark === 'object' && props.data.benchmark.hasOwnProperty('returnsYTD')) {
      series.push({
        name: "Benchmark",
        data: [
          parseFloat(props.data.benchmark.returnsYTD),
          parseFloat(props.data.benchmark.oneY),
          parseFloat(props.data.benchmark.fiveY),
          parseFloat(props.data.benchmark.tenY)
        ],
        color: "#a8b400",
        class: "not-bold",
        style: { cursor: "none" },
        events: {
          legendItemClick: function(e) {
            e.preventDefault();
          }
        }
      })
    }

    this.state = {
      chartConfig: {
        title: {
          text: ""
        },
        yAxis: {
          title: {
            text: "Price",
            style: {
              color: "#505050",
              fontFamily: "HelveticaNeue",
              fontSize: "14px"
              
            }
          },
          labels: {
            format: "{value}%",
            style: {
              color: "#505050",
              fontFamily: "HelveticaNeue",
              fontSize: "14px"
              
            }
          }
        },
        xAxis: {
          title: {
            text: "Returns Chart",
            style: {
              color: "#505050",
              fontFamily: "HelveticaNeue",
              fontSize: "14px"
              
            }
          },
          labels: {
            style: {
              color: "#505050",
              fontFamily: "HelveticaNeue",
              fontSize: "14px"
              
            }
         },
          categories: ["Qtr", "1 Year", "5 Year", "10 Year"]
        },
        credits: { enabled: false },
        legend: {
          layout: "horizontal",
          align: "left",
          verticalAlign: "top",
          x: 10,
          y: -30,
          itemStyle:{
            color: "#505050",
            fontFamily: "HelveticaNeue",
            fontSize: props.mobile ? "14px": "16px"
            
          }
        },   
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: series
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.data.investmentOption === nextProps.data.investmentOption) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { chartConfig } = this.state;

    return (
      <div className="highcharts-manual">
        <HighchartsReact
          highcharts={Highcharts}
          constructorType="stockChart"
          config={chartConfig}
        />
      </div>
    );
  }
}

Chart.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string,PropTypes.object]),
  mobile: PropTypes.bool
}
